import { render } from "./elem.vue?vue&type=template&id=17dede7d&scoped=true"
import script from "./elem.vue?vue&type=script&lang=js"
export * from "./elem.vue?vue&type=script&lang=js"

import "./elem.vue?vue&type=style&index=0&id=17dede7d&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dede7d"]])

export default __exports__